import { create } from "zustand";
import api from "../../utils/api";
import { getError } from "../../utils/getError";

export interface Role {
  id: string;
  name: string;
  description?: string;
  order?: number;
}

export interface RoleOption {
  value: string;
  label: string;
}

interface RolesStore {
  roles: Role[];
  loading: boolean;
  error: string | null;
  fetchRoles: () => Promise<void>;

  // Roles for brands/commands (cached separately)
  rolesBrands: RoleOption[];
  rolesBrandsLoading: boolean;
  rolesBrandsFetched: boolean;
  fetchRolesBrands: () => Promise<void>;
}

export const useRolesStore = create<RolesStore>((set, get) => ({
  roles: [],
  loading: false,
  error: null,

  // Roles for brands state
  rolesBrands: [],
  rolesBrandsLoading: false,
  rolesBrandsFetched: false,

  fetchRoles: async () => {
    if (get().loading) return;

    set({ loading: true, error: null });
    try {
      const { data } = await api.get("/roleList");
      set({ roles: data.data || [], loading: false });
    } catch (err: any) {
      set({ error: getError(err), loading: false });
    }
  },

  fetchRolesBrands: async () => {
    // Skip if already fetched or loading
    if (get().rolesBrandsFetched || get().rolesBrandsLoading) return;

    set({ rolesBrandsLoading: true });
    try {
      const { data } = await api.get("/roleList?limit=20");
      const options: RoleOption[] = (data.data || []).map((role: Role) => ({
        value: role.id,
        label: role.name,
      }));
      set({
        rolesBrands: options,
        rolesBrandsLoading: false,
        rolesBrandsFetched: true,
      });
    } catch (err: any) {
      console.error("Error fetching roles for brands:", err);
      set({ rolesBrandsLoading: false });
    }
  },
}));
